<template>
	<div>
		<v-data-table
			class="detailTable"
			:headers="computedHeadersDetail"
			:items="detailRowsInfoAndDataLocal"
			fix-header
			:no-data-text="txt.noDataInTable"
			:footer-props="{
				'items-per-page-options': [15, 50, 100]
			}"
			:items-per-page="15"
		>
			<template v-slot:[`item.main_person`]="{ item }">
					{{ (item.main_person === 1) ? txt.yes : txt.no }}
			</template>
			<template v-slot:[`item.is_group`]="{ item }">
					{{ (item.is_group === 1) ? txt.yes : txt.no }}
			</template>
			<template v-slot:[`item.guestcard_id`]="{ item }">
				{{ (item.guestcard_id !== null) ? item.guestcard_id : '-' }}
			</template>
			<template v-slot:[`item.check_in_date`]="{ item }">
				{{ moment(item.check_in_date).format('YYYY-MM-DD') }}
			</template>
			<template v-slot:[`item.check_out_date`]="{ item }">
				{{ moment(item.check_out_date).format('YYYY-MM-DD') }}
			</template>
			<template v-slot:[`item.residence_tax_amount`]="{ item }">
				{{ new Intl.NumberFormat(
					'de-DE',
					{ style: 'decimal', minimumFractionDigits: 2, maximumFractionDigits: 2})
					.format(Number(item.residence_tax_amount))
				}}
			</template>
			<template v-slot:[`item.quick_check_in_time`]="{ item }">
				{{ item.quick_check_in_time ? moment(item.quick_check_in_time).format('YYYY-MM-DD HH:mm:ss') : '' }}
			</template>
		</v-data-table>
	</div>
</template>

<script>
export default {
	name: 'RegistrationReportTableDetail',
	props: {
		detailRowsInfoAndData: {},
	},
	data() {
		return {
			test: false,
			detailRowsInfoAndDataLocal: this.detailRowsInfoAndData,
			txt: {
				noDataInTable: 'No data was loaded yet.',
				yes: 'yes',
				no: 'no',
			},
			headersDetail: [
				{ text: 'Form ID', value: 'from_id', selected: true },
				{ text: 'Person ID', value: 'person_id', selected: true },
				{ text: 'Is main person', value: 'main_person', selected: true, hide: 'mdAndDown'},
				{ text: 'Guestcard ID', value: 'guestcard_id', selected: true, hide: 'mdAndDown'},
				{ text: 'Registration status', value: 'registration_status', selected: true },
				{ text: 'Check in date', value: 'check_in_date', selected: true },
				{ text: 'Check out date', value: 'check_out_date', selected: true },
				{ text: 'Serviceprovider name', value: 'serviceprovider_name', selected: true, hide: 'mdAndDown'},
				{ text: 'Serviceprovider city - ZIP', value: 'serviceprovider_city_zip', selected: true, hide: 'mdAndDown'},
				{ text: 'Age group', value: 'age_group', selected: true, hide: 'mdAndDown'},
				{ text: 'Residence tax amount total', value: 'residence_tax_amount', selected: true, hide: 'mdAndDown'},
				{ text: 'Arrival by', value: 'arrival_by', selected: true, hide: 'mdAndDown'},
				{ text: 'Is group', value: 'is_group', selected: true, hide: 'mdAndDown'},
				{
					text: 'Adults in group',
					value: 'group_member_count_adult',
					selected: true,
					hide: 'mdAndDown',
				},
				{
					text: 'Adolescents in group',
					value: 'group_member_count_adolescent',
					selected: true,
					hide: 'mdAndDown',
				},
				{
					text: 'Kids in group',
					value: 'group_member_count_kid',
					selected: true,
					hide: 'mdAndDown',
				},
				{ text: 'Is email provided?', value: 'email_provided', selected: true, hide: 'mdAndDown' },
				{ text: 'Quick check in done?', value: 'quick_check_in_flag', selected: true, hide: 'mdAndDown' },
				{ text: 'Quick check in time', value: 'quick_check_in_time', selected: true, hide: 'mdAndDown' }
			],
		}
	},
	computed: {
		computedHeadersDetail() {
			return this.headersDetail
				.filter((h) => !h.hide || !this.$vuetify.breakpoint[h.hide])
				// eslint-disable-next-line no-prototype-builtins
				.filter(((h) => !h.hasOwnProperty('relevantInfo') || h.relevantInfo))
		},
	},
}
</script>

<style scoped>

.detailTable {
	background-color: rgba(128, 128, 128, 0);
	padding-left: unset;
}

</style>
